const PaginationComponent = (props) => {
  const currentPage = props.current || 1;
  const totalPage = props.total || 1;

  const getPageNumbers = () => {
    const pages = [];
    if (totalPage <= 10) {
      return Array.from({ length: totalPage }, (_, i) => i + 1);
    }
    pages.push(1);
    if (currentPage > 4) {
      pages.push("...");
    }
    // Pages ±3 around currentPage
    for (let i = Math.max(2, currentPage - 3); i <= Math.min(totalPage - 1, currentPage + 3); i++) {
      pages.push(i);
    }
    if (currentPage < totalPage - 3) {
      pages.push("...");
    }
    pages.push(totalPage);
    return pages;
  };

  return totalPage == 1 ? '' : (
    <div className="d-flex justify-content-end pagination mt-auto">
      {
        totalPage > 1 ? (<button className="fa fa-angle-left"
        onClick={() => props.handleChangePage(currentPage > 1 ? currentPage-1 : currentPage)}/>) : ''
      }
      
      {
        getPageNumbers().map((page, index) => (
          <span key={index} className={`page-item mx-1 ${currentPage == page ? 'active' : ''}`}
            onClick={() => props.handleChangePage(page)}>{page}</span>
        ))
      }
      {
        totalPage > 1 ? (<button className="fa fa-angle-right"
        onClick={() => props.handleChangePage(currentPage < totalPage ? currentPage+1 : totalPage)}/>) : ''
      }
      
    </div>
  )
}
export default PaginationComponent;